<!-- 耕雲導師圆寂及哀悼文 -->

<template>
  <!-- 耕雲導師墨寶 -->
  <div class="mourn flex-center">
    <table border="1" cellspacing="0" class="tableStyle">
      <tr>
        <th class="tableVirMidd" style="line-height: 0.95rem;" valign="middle" colspan="2">恩師於兩千年十月十一日凌晨圓寂！！<br>
          並於十一月五日舉行告別式.</th>
      </tr>
      <tr>
        <td class="tableVirMidd1 f80">{{$t('articleTitle')}}</td>
        <td class="tableVirMidd f80">{{$t('articleName')}}</td>
      </tr>
      <tr v-for="(item,index) in content" :key="index">
        <td class="tableVirMidd1" @click="linkToDetail(item)">{{item.news_title}}</td>
        <td class="tableVirMidd"> {{item.news_author}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  import {getMourningList} from '../../api/apis'

  // import barF5 from "../../components/barF5";
  export default {
    name: "",
    components: {
      // barF5
    },
    props: ['cateId','title'],
    data() {
      return {
        content:[],
      };
    },
    methods: {
      linkToDetail(item){
        this.$router.push({path:'/articleDetail',query:{name:'mourningArticle',id:item.id,title:this.title}});
      },
    },
    mounted(){
    this.cateId = this.cateId || 4;
    getMourningList(this.cateId).then(res => {
      this.content = res;
    })
  }
  };
</script>

<style scoped>
  .mourn {
    background-color: #000000;
    color: #ffffff;
    /* font-size: 0.69rem; */
     font-size: 0.85rem;
  }

  .tableStyle {
    width: 100%;
    
    margin: 0.64rem;

  }


  /* .tableStyle td {
    width: 50%;
  } */

  .tableVirMidd {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
  .tableVirMidd1{
    display: table-cell;
    vertical-align: middle;
  }

  table {
    border: 1px solid #ffffff;
  }

  th {
    border: 1px solid #ffffff;
    padding-left: 10px;
    height: 3rem;
  }

  td {
    border: solid #ffffff;
    border-width: 1px 1px 1px 1px;
    padding-left: 10px;
    height: 2.5rem;
  }

  .f80 {
    font-size: 0.85rem;
    font-weight: 600;
  }
</style>